import { useState, useCallback } from 'react';
import { MeetingFormData } from '../interfaces/interface';

export const useMeetingForm = () => {
  const [meetingFormData, setMeetingFormData] = useState<MeetingFormData>({
    subject: '',
    description: ''
  });

  const [manuallyEditedMeetingFormDataFields, setManuallyEditedMeetingFormDataFields] = useState<Set<keyof MeetingFormData>>(new Set());

  const handleInputChange = useCallback((field: keyof MeetingFormData, value: string) => {
    setMeetingFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  }, []);

  const updateFormData = useCallback((updates: Partial<MeetingFormData>) => {
    setMeetingFormData((prev) => ({ ...prev, ...updates }));
  }, []);

  const resetForm = useCallback(() => {
    setMeetingFormData({
      subject: '',
      description: ''
    });
  }, []);

  return {
    meetingFormData,
    setMeetingFormData,
    manuallyEditedMeetingFormDataFields,
    handleInputChange,
    updateFormData,
    resetForm
  };
};
